import { createSelector } from 'reselect'

export const root = state => state.get('sfdc')

export const getConversationMetrics = createSelector(
  root,
  root => root.conversationMetrics
)

export const getSFDCMetricMappings = createSelector(
  root,
  root => root.sfdcMetricMappings
)

export const getSFDCTaskFields = createSelector(
  root,
  root => root.sfdcTaskFields
)

export const getSFDCPatchMetricsLoading = createSelector(
  root,
  root => root.sfdcPatchMetricsLoading
)

export const getSFDCPatchMetricsErr = createSelector(
  root,
  root => root.sfdcPatchMetricsErr
)

export const isSFDCObjectListLoaded = createSelector(
  root,
  root => root.sfdcObjectList
)

export const sfdcObjectListErrStatus = createSelector(
  root,
  root => root.sfdcObjectListErr
)

export const isSFDCAccountFieldsListLoaded = createSelector(
  root,
  root => root.sfdcAccountFieldsList
)

export const isSFDCContactFieldsListLoaded = createSelector(
  root,
  root => root.sfdcContactFieldsList
)

export const isSFDCLeadFieldsListLoaded = createSelector(
  root,
  root => root.sfdcLeadFieldsList
)

export const sfdcFieldListErrStatus = createSelector(
  root,
  root => root.sfdcFieldsListErr
)

export const isSFDCLeadRoutingSettingsLoaded = createSelector(
  root,
  root => root.sfdcLeadRoutingSettings
)

export const sfdcLeadRoutingSettingsErrStatus = createSelector(
  root,
  root => root.sfdcLeadRoutingSettingsErr
)

export const getSalesforceEnrichmentByEmail = (state, email) => root(state).enrichment[email]

export const makeGetSalesforceEnrichmentByEmail = () => createSelector(
  getSalesforceEnrichmentByEmail,
  (salesforceEnrichment) => salesforceEnrichment
)

export const getSFDCEnrichmentFields = createSelector(
  root,
  root => root.sfdcEnrichmentFields
)

export const sfdcEnrichmentFieldsErrStatus = createSelector(
  root,
  root => root.sfdcEnrichmentFieldsErr
)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/sfdc/selectors.js